import moment from "@/utils/moment";
import holidayHelper from "@/utils/helpers/holiday";

const INITIAL_BUSINESS_HOUR = 7;
const FINAL_BUSINESS_HOUR = 22;

const STARTS_SLEEPING_TIME = 20;
const ENDS_SLEEPING_TIME = 8;
//Horário em que as limpezas contratadas no horário do sleeping time devem começar
const CRITICAL_TIME = 10;

const isHoliday = event => {
  let startsEvent = moment(event.starts_at);
  let holidays = holidayHelper.daysWithDisabledPurchase();
  let isHoliday = holidays.includes(startsEvent.format("MM-DD"));
  return isHoliday;
};

const isTomorrow = startsAt =>
  moment(startsAt).format("Y-MM-DD") ===
  moment()
    .add(1, "days")
    .format("Y-MM-DD");
const isToday = startsAt =>
  moment(startsAt).format("Y-MM-DD") === moment().format("Y-MM-DD");
const isBeforeCriticalTime = startsAt =>
  moment(startsAt).hour() < CRITICAL_TIME;
const isTodayBeforeCriticalTime = startsAt =>
  isToday(startsAt) && isBeforeCriticalTime(startsAt);
const isTomorrowOrTodayBeforeCriticalTime = startsAt =>
  isTomorrow(startsAt) || isTodayBeforeCriticalTime(startsAt);
const isUserInSleepingTime = () =>
  moment().hours() >= STARTS_SLEEPING_TIME ||
  moment().hours() <= ENDS_SLEEPING_TIME;
const isEventStartingBeforeCriticalTime = startsAt =>
  moment(startsAt).hour() <= CRITICAL_TIME;
const isEventEndingBeforeCriticalTime = endsAt =>
  moment(endsAt).hour() <= CRITICAL_TIME;

//Se o usuário está no sleeping time, o evento é amanhã, começa antes da hora critica e termina antes da hora critica remove o evento
const checkSleepingTime = event => {
  let startsAt = event.starts_at;
  let endsAt = event.ends_at;

  return (
    isUserInSleepingTime() &&
    isTomorrowOrTodayBeforeCriticalTime(startsAt) &&
    isEventStartingBeforeCriticalTime(startsAt) &&
    isEventEndingBeforeCriticalTime(endsAt)
  );
};

//Se o usuário está no sleeping time, o evento é amanhã, começa antes da hora critica e termina depois da hora critica retorna o horário inicial para às 10 horas, se não mantem o horário inicial do evento
const getValidInitialHour = event => {
  let startsAt = event.starts_at;
  let endsAt = event.ends_at;

  return isUserInSleepingTime() &&
    isTomorrowOrTodayBeforeCriticalTime(startsAt) &&
    isEventStartingBeforeCriticalTime(startsAt) &&
    !isEventEndingBeforeCriticalTime(endsAt)
    ? 10
    : moment(event.starts_at).hour();
};

const getValidInitialHourByDuration = duration =>
  FINAL_BUSINESS_HOUR - duration;

const initialBusinessHour = () => INITIAL_BUSINESS_HOUR;
const finalBusinessHour = () => FINAL_BUSINESS_HOUR;

export default {
  isHoliday,
  isTomorrow,
  isToday,
  isUserInSleepingTime,
  checkSleepingTime,
  getValidInitialHour,
  getValidInitialHour,
  getValidInitialHourByDuration,
  initialBusinessHour,
  finalBusinessHour
};



// WEBPACK FOOTER //
// ./src/utils/helpers/event.js